import { CloudRain, Car, AlertTriangle, Ban, Snowflake, CloudFog, CloudHail, Waves, Siren } from "lucide-react";

export const REPORT_TYPES = {
  rain: { label: "Yolda Yoğun Yağmur", color: "#3B82F6", icon: CloudRain },
  traffic: { label: "Yol Sıkışıklığı", color: "#F97316", icon: Car },
  accident: { label: "Kaza", color: "#EF4444", icon: AlertTriangle },
  closed: { label: "Yol Kapalı", color: "#B91C1C", icon: Ban },
  ice: { label: "Buzlanma / Kaygan", color: "#67E8F9", icon: Snowflake },
  fog: { label: "Yoğun Sis", color: "#94A3B8", icon: CloudFog },
  hail: { label: "Dolu", color: "#A855F7", icon: CloudHail },
  flood: { label: "Su Baskını", color: "#0EA5E9", icon: Waves },
  sos: { label: "Acil Durum (SOS)", color: "#DC2626", icon: Siren },
};
